import { render } from "./search-bar.vue?vue&type=template&id=5beb665c"
import script from "./search-bar.vue?vue&type=script&lang=js"
export * from "./search-bar.vue?vue&type=script&lang=js"

import "./search-bar.vue?vue&type=style&index=0&id=5beb665c&lang=scss"

import exportComponent from "/buddy/derek-lam-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__